export interface NotificationChannel {
  id: string;
  label: string;
  description: string;
  icon: string;
  enabled: boolean;
}

export interface RadioNotificationConfig {
  radioId: number;
  radioName: string;
  radioImage: string;
  radioFrequency: string;
  liveStarted: boolean;
  newEvent: boolean;
  newContest: boolean;
}

export interface ProgramNotificationConfig {
  programId: number;
  programName: string;
  programImage: string;
  radioName: string;
  programStarting: boolean;
  newEpisode: boolean;
}

export interface HostNotificationConfig {
  hostId: number;
  hostName: string;
  hostImage: string;
  radioName: string;
  hostLiveStarted: boolean;
  newPost: boolean;
}

export const notificationChannels: NotificationChannel[] = [
  { id: "push", label: "Notificaciones Push", description: "Recibí alertas incluso con la app cerrada", icon: "ri-smartphone-line", enabled: true },
  { id: "email", label: "Correo Electrónico", description: "Resumen diario y alertas importantes por email", icon: "ri-mail-line", enabled: false },
  { id: "in_app", label: "Dentro de la App", description: "Campanita de notificaciones en tiempo real", icon: "ri-notification-3-line", enabled: true },
];

export const globalNotificationToggles = [
  { id: "radio_live", label: "Radio en Vivo", description: "Cuando una de tus radios favoritas inicia transmisión", icon: "ri-broadcast-line", color: "text-rose-500", enabled: true },
  { id: "program_starts", label: "Programa Inicia", description: "Recordatorio cuando un programa que seguís está por comenzar", icon: "ri-mic-line", color: "text-emerald-500", enabled: true },
  { id: "host_starts", label: "Locutor Inicia", description: "Cuando un locutor que seguís entra al aire", icon: "ri-user-voice-line", color: "text-amber-500", enabled: true },
  { id: "event_starts", label: "Evento Inicia", description: "Notificación cuando un evento que marcaste está por comenzar", icon: "ri-calendar-event-line", color: "text-violet-500", enabled: true },
  { id: "contest_starts", label: "Concurso Inicia", description: "Cuando se activa un concurso de tus radios favoritas", icon: "ri-trophy-line", color: "text-orange-500", enabled: true },
];

export const radioNotifications: RadioNotificationConfig[] = [
  {
    radioId: 1,
    radioName: "La Mexicana FM",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors&width=200&height=200&seq=sn-radio-mexicana&orientation=squarish",
    radioFrequency: "98.7 FM",
    liveStarted: true,
    newEvent: true,
    newContest: true,
  },
  {
    radioId: 2,
    radioName: "Radio Nueva Actitud",
    radioImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20palette&width=200&height=200&seq=sn-radio-nueva&orientation=squarish",
    radioFrequency: "102.5 FM",
    liveStarted: true,
    newEvent: false,
    newContest: true,
  },
  {
    radioId: 3,
    radioName: "Rock Total Radio",
    radioImage: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme&width=200&height=200&seq=sn-radio-rock&orientation=squarish",
    radioFrequency: "95.3 FM",
    liveStarted: true,
    newEvent: true,
    newContest: false,
  },
  {
    radioId: 4,
    radioName: "Radio Fe y Esperanza",
    radioImage: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors&width=200&height=200&seq=sn-radio-fe&orientation=squarish",
    radioFrequency: "88.1 FM",
    liveStarted: false,
    newEvent: true,
    newContest: false,
  },
  {
    radioId: 5,
    radioName: "Banda Radio MX",
    radioImage: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20green%20colors&width=200&height=200&seq=sn-radio-banda&orientation=squarish",
    radioFrequency: "107.9 FM",
    liveStarted: true,
    newEvent: true,
    newContest: true,
  },
  {
    radioId: 6,
    radioName: "La Kalle 99.9",
    radioImage: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20coral&width=200&height=200&seq=sn-radio-kalle&orientation=squarish",
    radioFrequency: "99.9 FM",
    liveStarted: true,
    newEvent: false,
    newContest: false,
  },
];

export const programNotifications: ProgramNotificationConfig[] = [
  {
    programId: 1,
    programName: "El Sabor del Mediodía",
    programImage: "https://readdy.ai/api/search-image?query=Lively%20radio%20program%20cover%20art%20with%20warm%20Latin%20colors%2C%20food%20and%20music%20theme%2C%20bright%20festive%20design%2C%20square%20format&width=200&height=200&seq=sn-prog-sabor&orientation=squarish",
    radioName: "La Mexicana FM",
    programStarting: true,
    newEpisode: true,
  },
  {
    programId: 2,
    programName: "Tardes de Pop",
    programImage: "https://readdy.ai/api/search-image?query=Colorful%20pop%20music%20radio%20show%20cover%20art%2C%20vibrant%20pink%20and%20coral%20tones%2C%20modern%20youthful%20design%20with%20music%20elements&width=200&height=200&seq=sn-prog-pop&orientation=squarish",
    radioName: "La Kalle 99.9",
    programStarting: true,
    newEpisode: false,
  },
  {
    programId: 3,
    programName: "Rock Total en Vivo",
    programImage: "https://readdy.ai/api/search-image?query=Rock%20radio%20program%20cover%20art%20with%20guitars%20and%20concert%20lights%2C%20dark%20background%20with%20red%20and%20electric%20blue%20accents&width=200&height=200&seq=sn-prog-rock&orientation=squarish",
    radioName: "Rock Total Radio",
    programStarting: true,
    newEpisode: true,
  },
  {
    programId: 4,
    programName: "Mañanas de Bendición",
    programImage: "https://readdy.ai/api/search-image?query=Christian%20morning%20radio%20program%20cover%20art%2C%20warm%20sunrise%20tones%2C%20dove%20and%20cross%20symbols%2C%20peaceful%20spiritual%20design&width=200&height=200&seq=sn-prog-fe&orientation=squarish",
    radioName: "Radio Fe y Esperanza",
    programStarting: false,
    newEpisode: true,
  },
  {
    programId: 5,
    programName: "Carrusel Deportivo",
    programImage: "https://readdy.ai/api/search-image?query=Sports%20radio%20program%20cover%20art%2C%20soccer%20ball%20and%20stadium%20theme%2C%20dynamic%20blue%20and%20gold%20design%2C%20energetic%20feel&width=200&height=200&seq=sn-prog-deportes&orientation=squarish",
    radioName: "Deportes Total Radio",
    programStarting: true,
    newEpisode: true,
  },
];

export const hostNotifications: HostNotificationConfig[] = [
  {
    hostId: 1,
    hostName: "Valentina Ríos",
    hostImage: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20warm%20smiling%20Latina%20radio%20host%20woman%2C%20professional%20studio%20headshot%2C%20friendly%20expression%2C%20soft%20lighting&width=200&height=200&seq=sn-host-valentina&orientation=squarish",
    radioName: "La Mexicana FM",
    hostLiveStarted: true,
    newPost: true,
  },
  {
    hostId: 2,
    hostName: "Roberto Aguilar",
    hostImage: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20charismatic%20Latino%20male%20radio%20host%2C%20professional%20studio%20headshot%2C%20confident%20smile%2C%20warm%20lighting&width=200&height=200&seq=sn-host-roberto&orientation=squarish",
    radioName: "Radio Nueva Actitud",
    hostLiveStarted: true,
    newPost: false,
  },
  {
    hostId: 3,
    hostName: "Andrés Castillo",
    hostImage: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20handsome%20Latino%20male%20radio%20broadcaster%2C%20stylish%20professional%20headshot%2C%20friendly%20expression%2C%20studio%20lighting&width=200&height=200&seq=sn-host-andres&orientation=squarish",
    radioName: "Rock Total Radio",
    hostLiveStarted: false,
    newPost: true,
  },
  {
    hostId: 4,
    hostName: "Camila Ortega",
    hostImage: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20beautiful%20Latina%20female%20radio%20host%2C%20elegant%20professional%20headshot%2C%20bright%20expression%2C%20soft%20studio%20lighting&width=200&height=200&seq=sn-host-camila&orientation=squarish",
    radioName: "Banda Radio MX",
    hostLiveStarted: true,
    newPost: true,
  },
  {
    hostId: 5,
    hostName: "Javier Solís",
    hostImage: "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20serious%20Latino%20male%20radio%20sports%20commentator%2C%20professional%20headshot%2C%20intense%20expression%2C%20dramatic%20studio%20lighting&width=200&height=200&seq=sn-host-javier&orientation=squarish",
    radioName: "Deportes Total Radio",
    hostLiveStarted: true,
    newPost: true,
  },
];